import React, { ComponentProps } from 'react';

import { StyledCheckbox } from './styled';

export function Checkbox(props: ComponentProps<typeof StyledCheckbox>) {
  return <StyledCheckbox {...props} type="checkbox" />;
}
